"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFranchiseFaq = void 0;
const initFranchiseFaq = ($franchiseFaq) => {
    const els = $franchiseFaq.querySelectorAll('.franchise-faq__item--opened-xl-up .accordion__header-button');
    for (let $el of els) {
        if (window.innerWidth >= 1600) {
            $el.click();
        }
    }
};
exports.initFranchiseFaq = initFranchiseFaq;
